import BN from 'bn.js';
import JSBI from 'jsbi';

const ZERO = JSBI.BigInt(0);
const ZERO_BN = new BN(0);

export { ZERO, ZERO_BN };
